import { render, staticRenderFns } from "./PieChartApex.vue?vue&type=template&id=01bb7721"
import script from "./PieChartApex.vue?vue&type=script&lang=js"
export * from "./PieChartApex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports